var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"add-button-dialog-container"},[_c('div',{staticClass:"add-button",style:(_vm.addButtonStyle),on:{"click":_vm.onAddButtonClicked}},[_vm._v("\n    ✚\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }